import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import Newborn from "./sections/Newborn";
import Mission from "./sections/Mission";
import Timeline from "./sections/Timeline";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <Newborn />
      <Mission />
      <Timeline />
      <Footer />
    </div>;
}